import {
  FiUser,
  FiMail,
  FiPhone,
  FiUsers,
  FiCreditCard,
  FiCalendar,
  FiHome,
  FiDollarSign,
  FiCheckCircle,
} from 'react-icons/fi';
import { LiaRupeeSignSolid } from 'react-icons/lia';
import { useEffect } from 'react';

const VerifyDetails = ({ currentStep, setCurrentStep, totalSteps }) => {
  // Get bookingDetails from local storage or props
  const bookingDetails = JSON.parse(localStorage.getItem('bookingDetails')) || {};
  const primaryBooking = bookingDetails.primaryBooking || {};
  const paymentStatus = primaryBooking.payment_status || {};
  const securityDeposit = paymentStatus.security_deposit || {};

  // Format date for better readability
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    const handlePopState = () => {
      localStorage.removeItem('bookingDetails');
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <div className="">
      <h2 className="text-xl font-bold mb-1 text-gray-900">Verify Your Reservation</h2>
      <p className="text-gray-600 text-sm mb-4">
        Verify your reservation information before check-in
      </p>

      <div className="space-y-6">
        {/* Guest Details */}
        <div>
          <h4 className="font-semibold text-lg mb-3 flex items-center gap-2">
            Reservation Details
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-5 gap-3">
            {[
              {
                label: 'Full Name',
                value: bookingDetails.primary_guest
                  ?.split(' ')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' '),
                icon: <FiUser size={16} />,
              },

              {
                label: 'Email',
                value: primaryBooking.guest_email,
                icon: <FiMail size={16} />,
              },
              {
                label: ' Mobile number',
                value: primaryBooking.guest_phone,
                icon: <FiPhone size={16} />,
              },
              {
                label: 'Guests',
                value: primaryBooking.number_of_guests,
                icon: <FiUsers size={16} />,
              },
              {
                label: 'Room Type',
                value: primaryBooking.room_type?.name,
                icon: <FiHome size={16} />,
              },
              {
                label: 'Reservation Number',
                value: primaryBooking.order_id,
                icon: <FiCreditCard size={16} />,
              },

              {
                label: 'Checkin Date',
                value: formatDate(primaryBooking.checkin_date),
                icon: <FiCalendar size={16} />,
              },
              {
                label: 'Checkout Date',
                value: formatDate(primaryBooking.checkout_date),
                icon: <FiCalendar size={16} />,
              },
              {
                label: 'No of nights',
                value: primaryBooking.length_of_stay,
                icon: <FiHome size={16} />,
              },
            ].map(({ label, value, icon }) => (
              <div key={label} className="bg-gray-50 p-3 rounded border">
                <div className="text-xs font-medium text-gray-500 uppercase mb-1 flex items-center gap-1">
                  {icon} {label}
                </div>
                <p className="text-sm font-medium">{value || 'N/A'}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Payment Information */}
        <div>
          <h4 className="font-semibold text-lg mb-3 flex items-center gap-2">Payment Details</h4>
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mb-8">
            <div className="bg-gray-50 p-3 rounded border">
              <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
                <FiCheckCircle size={16} /> Deposit Amount
              </div>
              <p className="font-bold">₹{(securityDeposit.amount || 0).toLocaleString('en-IN')}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded border">
              <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
                <FiCreditCard size={16} /> Amount Paid
              </div>
              <p className="font-bold">
                ₹{(paymentStatus.total_paid || 0).toLocaleString('en-IN')}
              </p>
            </div>

            <div className="bg-gray-50 p-3 rounded border">
              <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
                <LiaRupeeSignSolid size={16} />
                Amount Due
              </div>
              <p className="font-bold">
                ₹{(paymentStatus.due_amount || 0).toLocaleString('en-IN')}
              </p>
            </div>

            <div className="bg-gray-50 p-3 rounded border">
              <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
                <FiCreditCard size={16} /> Total Amount
              </div>
              <p className="font-bold">
                ₹{(paymentStatus.total_amount || 0).toLocaleString('en-IN')}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-4 border-t border-gray-200">
        <button
          onClick={() => setCurrentStep(currentStep + 1)}
          className="w-1/4 bg-black text-white py-2 rounded hover:bg-gray-800 transition font-medium"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default VerifyDetails;

// import {
//   FiUser,
//   FiMail,
//   FiPhone,
//   FiUsers,
//   FiCreditCard,
//   FiCalendar,
//   FiHome,
//   FiDollarSign,
//   FiCheckCircle,
// } from "react-icons/fi";
// import { LiaRupeeSignSolid } from "react-icons/lia";
// import { useEffect } from "react";

// const VerifyDetails = ({ currentStep, setCurrentStep, totalSteps }) => {
//   // Get bookingDetails from local storage or props
//   const bookingDetails =
//     JSON.parse(localStorage.getItem("bookingDetails")) || {};
//   const primaryBooking = bookingDetails.primaryBooking || {};
//   const paymentStatus = primaryBooking.payment_status || {};

//   // Format date for better readability
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//    useEffect(() => {
//     const handlePopState = () => {
//       localStorage.removeItem("bookingDetails");
//     };

//     window.addEventListener("popstate", handlePopState);

//     return () => {
//       window.removeEventListener("popstate", handlePopState);
//     };
//   }, []);

//   return (
//     <div className="">
//       <h2 className="text-xl font-bold mb-1 text-gray-900">
//         Verify Your Reservation
//       </h2>
//       <p className="text-gray-600 text-sm mb-4">
//         Verify your reservation information before check-in
//       </p>

//       <div className="space-y-6">
//         {/* Guest Details */}
//         <div>
//           <h4 className="font-semibold text-lg mb-3 flex items-center gap-2">
//             Reservation Details
//           </h4>
//           <div className="grid grid-cols-1 sm:grid-cols-5 gap-3">
//             {[
//               {
//                 label: "Full Name",
//                 value: bookingDetails.primary_guest
//                   ?.split(" ")
//                   .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//                   .join(" "),
//                 icon: <FiUser size={16} />,
//               },

//               {
//                 label: "Email",
//                 value: primaryBooking.guest_email,
//                 icon: <FiMail size={16} />,
//               },
//               {
//                 label: " Mobile number",
//                 value: primaryBooking.guest_phone,
//                 icon: <FiPhone size={16} />,
//               },
//               {
//                 label: "Guests",
//                 value: primaryBooking.number_of_guests,
//                 icon: <FiUsers size={16} />,
//               },
//               {
//                 label: "Room Type",
//                 value: primaryBooking.room_type?.name,
//                 icon: <FiHome size={16} />,
//               },
//               {
//                 label: "Reservation Number",
//                 value: primaryBooking.order_id,
//                 icon: <FiCreditCard size={16} />,
//               },

//               {
//                 label: "Checkin Date",
//                 value: formatDate(primaryBooking.checkin_date),
//                 icon: <FiCalendar size={16} />,
//               },
//               {
//                 label: "Checkout Date",
//                 value: formatDate(primaryBooking.checkout_date),
//                 icon: <FiCalendar size={16} />,
//               },
//               {
//                 label: "No of nights",
//                 value: primaryBooking.length_of_stay,
//                 icon: <FiHome size={16} />,
//               },
//             ].map(({ label, value, icon }) => (
//               <div key={label} className="bg-gray-50 p-3 rounded border">
//                 <div className="text-xs font-medium text-gray-500 uppercase mb-1 flex items-center gap-1">
//                   {icon} {label}
//                 </div>
//                 <p className="text-sm font-medium">{value || "N/A"}</p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Payment Information */}
//         <div>
//           <h4 className="font-semibold text-lg mb-3 flex items-center gap-2">
//             Payment Details
//           </h4>
//           <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mb-8">
//             <div className="bg-gray-50 p-3 rounded border">
//               <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
//                 <FiCheckCircle size={16} /> Deposit Amount
//               </div>
//               <p>{paymentStatus.deposit_paid ? "Yes" : "No"}</p>
//             </div>

//             <div className="bg-gray-50 p-3 rounded border">
//               <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
//                 <LiaRupeeSignSolid size={16} />
//                 Due Amount
//               </div>
//               <p className="font-bold">
//                 ₹{(paymentStatus.due_amount || 0).toLocaleString("en-IN")}
//               </p>
//             </div>

//             <div className="bg-gray-50 p-3 rounded border">
//               <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
//                 <FiCreditCard size={16} /> Total Paid
//               </div>
//               <p className="font-bold">
//                 ₹{(paymentStatus.total_paid || 0).toLocaleString("en-IN")}
//               </p>
//             </div>

//             <div className="bg-gray-50 p-3 rounded border">
//               <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
//                 <FiCreditCard size={16} /> Total Amount
//               </div>
//               <p className="font-bold">
//                 ₹{(paymentStatus.total_amount || 0).toLocaleString("en-IN")}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="flex justify-end pt-4 border-t border-gray-200">
//         {/* <button
//           disabled={true}
//           className="w-1/6 bg-gray-200 text-gray-500 py-2 rounded font-medium cursor-not-allowed"
//         >
//           Back
//         </button> */}
//         <button
//           onClick={() => setCurrentStep(currentStep + 1)}
//           className="w-1/4 bg-black text-white py-2 rounded hover:bg-gray-800 transition font-medium"
//         >
//           Next Step
//         </button>
//       </div>
//     </div>
//   );
// };

// export default VerifyDetails;
